/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class JobsIcon extends BaseIcon {
  getChildren = () => [
  <g fillRule={'evenodd'} clipRule={'evenodd'} fill={ this.getColor() }>
    <path d="M16,12v-1l-1.1-0.2c-0.1-0.4-0.3-0.8-0.5-1.1l0.6-1L14.3,8l-0.9,0.6c-0.3-0.2-0.7-0.4-1.1-0.5L12,7h-1l-0.2,1.1
      c-0.2,0-0.3,0.1-0.5,0.2L11,9c0.1,0,0.3,0,0.5,0c1.4,0,2.5,1.1,2.5,2.5S12.9,14,11.5,14S9,12.9,9,11.5c0-0.2,0-0.3,0-0.5l-0.7-0.7
      c-0.1,0.2-0.1,0.3-0.2,0.5L7,11v1l1.1,0.2c0.1,0.4,0.3,0.8,0.5,1.1l-0.6,1L8.7,15l0.9-0.6c0.3,0.2,0.7,0.4,1.1,0.5L11,16h1l0.2-1.1
      c0.4-0.1,0.8-0.3,1.1-0.5l0.9,0.6l0.7-0.7l-0.6-0.9c0.2-0.3,0.4-0.7,0.5-1.1L16,12z"/>
    <circle cx="11.5" cy="11.5" r="1.5"/>
    <path d="M7.9,3.8C7.8,3.3,7.7,3,7.4,2.6L8,1.7L7.3,1L6.4,1.6C6,1.3,5.7,1.2,5.2,1.1L5,0H4L3.8,1.1
      C3.3,1.2,3,1.3,2.6,1.6L1.7,1L1,1.7l0.6,0.9C1.3,3,1.2,3.3,1.1,3.8L0,4v1l1.1,0.2C1.2,5.7,1.3,6,1.6,6.4L1,7.3L1.7,8l0.9-0.6
      C3,7.7,3.3,7.8,3.8,7.9L4,9h1l0.2-1.1c0.2,0,0.3-0.1,0.5-0.2L5,7C4.8,7,4.7,7,4.5,7C3.1,7,2,5.9,2,4.5S3.1,2,4.5,2S7,3.1,7,4.5
      C7,4.7,7,4.8,7,5l0.7,0.7c0.1-0.2,0.1-0.3,0.2-0.5L9,5V4L7.9,3.8z"/>
    <circle cx="4.5" cy="4.5" r="1.5"/>
    <rect x="7.4" y="2.8" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -3.2744 7.8946)" width="1" height="10.2"/>
  </g>
  ]
  getViewBox = () => '0 0 16 16'
}
